import { makeAutoObservable, runInAction } from "mobx";
import { ragAsk } from "@/features/rag/api/rag";
import { RagResponse } from "@/features/rag/model/types";

export class RagStore {
    answer: RagResponse | undefined;
    loading: boolean = false;
    error: string = "";

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    askRagQuestion = async (requestBody: {
        question: string;
        limit: number;
        min_relevance: number;
        debug: boolean;
    }) => {
        this.loading = true;
        this.error = "";
        this.answer = undefined;

        try {
            const data = await ragAsk(requestBody);
            runInAction(() => {
                this.answer = data;
            });
        } catch (err) {
            runInAction(() => {
                this.error = (err as Error).message;
            });
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    };
}
